import type { IconData } from '@stacksjs/iconify-core'

export const drop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M394.633 220.663L269.475 25.174a16 16 0 0 0-26.95 0L117.364 220.665A170.53 170.53 0 0 0 84.1 322.3c0 94.785 77.113 171.9 171.9 171.9s171.9-77.113 171.9-171.9a170.52 170.52 0 0 0-33.267-101.637M256 462.2c-77.14 0-139.9-62.758-139.9-139.9a138.76 138.76 0 0 1 27.321-83.058q.319-.432.608-.884L256 63.475l111.967 174.884q.288.453.608.884A138.75 138.75 0 0 1 395.9 322.3c0 77.141-62.76 139.9-139.9 139.9\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default drop
